export default {"src":"/_next/static/media/success-icon.1c3c7645.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};